import styles from './Account.module.css';
import { PushpinOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setUpgradeModalOpen } from '../../actions';

interface Props {
  accountWasCanceled: boolean;
}

const AccountDisabledBanner = ({ accountWasCanceled }: Props) => {
  const dispatch = useDispatch();

  const handleOpenUpgradeModal = () => {
    dispatch(setUpgradeModalOpen(true));
  };

  const suggestedAction = accountWasCanceled ? (
    <span>
      Please contact our team at{' '}
      <a href={'mailto:support@giide.com'}>support@giide.com</a> if you'd like
      to restart your subscription.
    </span>
  ) : (
    <span>
      If you would like to continue creating and sharing giides, you must
      upgrade your account. Click{' '}
      <button onClick={handleOpenUpgradeModal}>here</button> to find a plan that
      works best for you.
    </span>
  );

  const header = accountWasCanceled
    ? 'Your subscription is canceled'
    : 'Your free trial has ended';

  return (
    <div className={styles.accountDisabledBanner}>
      <PushpinOutlined className={styles.alertIcon} />
      <div className={styles.accountDisabledText}>
        <h2>{header}</h2>
        <p>
          All giides you have created will be deactivated, no longer viewable to
          the public, and no longer editable. {suggestedAction}
        </p>
      </div>
    </div>
  );
};

export default AccountDisabledBanner;
